import { ls } from 'shared/utils/ls';

const { getLS } = ls();

type UserInfo = {
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
};

const getUserInfo = (): UserInfo => {
  const accountData = getLS('guardian_account') || getLS('user');
  const attributes = JSON.parse(accountData)?.attributes;

  const email = attributes?.email;
  const firstName = attributes?.first_name;
  const lastName = attributes?.last_name;
  const fullName = attributes?.full_name;

  if (email && firstName && lastName && fullName) {
    return {
      email,
      firstName,
      lastName,
      fullName,
    };
  }
};

export { getUserInfo };
